import { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  CardTitle,
  Form,
  FormGroup,
  Card,
  CardHeader,
  CardBody,
  Button,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

export default function AddCourseToProgramLicenseModal(props) {
  const [selectedCoursesToAdd, setSelectedCoursesToAdd] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [availabledCoursesToAdd, setAvailabledCoursesToAdd] = useState([]);
  const courses = useSelector((state) => state.coursesListReducer);
  const handleChange = (selected) => {
    setSelectedCoursesToAdd(selected);
  };

  useEffect(() => {
    if (!courses.isLoading && props.licenseId) {
      let tempAllCourses = [];
      courses.result.forEach((program) => {
        program.courses.forEach((course) => {
          if (!tempAllCourses.some((acc) => acc.id === course.id)) {
            tempAllCourses.push(course);
          }
        });
      });
      tempAllCourses.push(...courses.orphanCourses);
      setAllCourses(tempAllCourses);
    }
  }, [props.licenseId, courses, props.licenseName]);

  useEffect(() => {
    if (!courses.isLoading && props.licenseId) {
      let currentLicenseWithCourses = courses.result.filter(
        (lic) => lic.program.id === props.licenseId
      );
      let tempaAailabledCoursesToAdd = [];
      allCourses.forEach((course) => {
        if (
          !currentLicenseWithCourses[0].courses.some((c) => c.id === course.id)
        ) {
          let selectObject = { label: course.name, value: course.id };
          tempaAailabledCoursesToAdd.push(selectObject);
        }
      });
      setAvailabledCoursesToAdd(tempaAailabledCoursesToAdd);
    }
  }, [allCourses, courses.result, props.licenseId, courses.isLoading]);

  return (
    <Modal isOpen={props.isOpen} toggle={() => props.toggle(null, null)}>
      <ModalBody>
        <CardTitle>{props.licenseName}</CardTitle>

        <Card>
          <CardHeader>
            <FontAwesomeIcon icon="plus-circle" className="text-primary me-1" />
            <FormattedMessage id="ChooseExistingCourses" />
          </CardHeader>
          <CardBody>
            <Form>
              <FormGroup>
                <Select
                  placeholder="Välj kurser"
                  isMulti
                  noOptionsMessage={() =>
                    "Alla kurser finns redan till programlicensen"
                  }
                  onChange={(selected) => handleChange(selected)}
                  options={availabledCoursesToAdd}
                />
              </FormGroup>
            </Form>
          </CardBody>
        </Card>
      </ModalBody>
      <ModalFooter>
        <Button
          outline
          color="secondary"
          onClick={() => props.toggle(null, null)}
        >
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          outline
          color="primary"
          disabled={selectedCoursesToAdd.length === 0 || props.posting}
          onClick={() => props.addCourses(selectedCoursesToAdd)}
        >
          {props.posting ? (
            <FormattedMessage id="AddingDotDotDot" />
          ) : (
            <FormattedMessage id="Add" />
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
